import React from "react";

export const BorderedRecordIcon = ({ Icon, className, border = true, ...props }: any) => {
  const adjustedClassName = (className || "").replace(/text-gray-[789]00/g, "text-gray-500");

  const iconSize = border ? "14px" : "16px";

  return (
    // Outer wrapper defaults to 16x16 via className to perfectly align with sibling text items
    <div
      className={`${adjustedClassName} flex items-center justify-center`}
      style={props.style}
      {...props}
    >
      <div style={{ position: "relative", width: iconSize, height: iconSize }}>
        {/* SVG rendered to exact size based on mode, and scaled up when unbordered to compensate for built-in SVG path padding compared to standard Lucide icons */}
        <Icon
          width={iconSize}
          height={iconSize}
          style={{
            display: "block",
            color: "currentColor",
            transform: border ? "none" : "scale(1.3)",
          }}
        />
        {/* Absolute border overlay matched to devtools computed spec */}
        {border && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: iconSize,
              height: iconSize,
              border: "1px solid rgba(0, 0, 0, 0.05)",
              borderRadius: "30%",
              boxSizing: "border-box",
              pointerEvents: "none",
            }}
          />
        )}
      </div>
    </div>
  );
};
